import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-terracotta text-white relative overflow-hidden" data-id="element-150">
      {/* Background depth elements */}
      <div className="absolute inset-0 opacity-20 pointer-events-none" data-id="element-151">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-gradient-to-b from-white/20 to-transparent rounded-full blur-[80px]" data-id="element-152"></div>
      </div>

      <div className="container mx-auto px-6 max-w-3xl text-center relative z-10" data-id="element-153">
        <FadeIn data-id="element-154">
          <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-3xl p-8 md:p-12 shadow-volumetric" data-id="element-155">
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-156">
              Por menos de lo que cuesta una cena…
            </h2>
            <p className="text-xl md:text-2xl text-white/90 mb-12 font-medium" data-id="element-157">
              Puedes empezar a recuperar tu sueño esta misma noche.
            </p>

            <div className="mb-10" data-id="element-158">
              <span className="text-sm uppercase tracking-widest font-bold text-white/70 mb-2 block" data-id="element-159">
                Valor del programa
              </span>
              <div className="flex flex-col items-center justify-center gap-1" data-id="element-160">
                <span className="text-2xl text-white/50 line-through decoration-white/50" data-id="element-161">
                  44,99€
                </span>
                <span className="text-5xl md:text-6xl font-serif font-bold text-white" data-id="element-162">
                  6,61€
                </span>
                <span className="text-sm text-white/60" data-id="element-163">IVA incluido</span>
              </div>
            </div>

            <p className="mb-6 text-lg md:text-xl font-serif italic text-white/90" data-id="element-164">
              Si esta noche vuelves a despertarte a las 3am… vas a seguir igual
              mañana.
            </p>

            <CTAButton className="!bg-white !text-terracotta-dark !shadow-[0_6px_0_#E8D8C8,0_15px_20px_rgba(0,0,0,0.2)] active:!shadow-[0_0px_0_#E8D8C8,0_0px_0_rgba(0,0,0,0.2)] hover:bg-cream" data-id="element-165" />

            <p className="mt-4 text-base font-bold text-white" data-id="element-166">
              Empiezas hoy. Notas cambios en días.
            </p>
            <p className="mt-2 text-sm text-white/70" data-id="element-167">
              Pago único. Acceso de por vida. Garantía de 7 días.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}